export const SetupRoutes = {
  selectSubType: 'select-submission-subtype',
  appealsSetup: 'appeal-submission-setup',
  studySetup: 'study-submission-setup',
  existingStudyFound: 'existing-study-found',
  selectStudy: 'select-study',
  mtrSetup: 'mtr-submission-setup',
  selectSite: 'select-site',
  createSubmission: 'create-submission',
  copySubmission: 'copy-submission',
};

export const WorkspaceTypes = {
  cir: 'Add PI/Site to Existing Study',
  mtr: 'Modification to Research',
  newStudy: 'New Study For Initial Review',
};
